import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Maker from './Maker'
import EditAndViewMaker from './EditAndViewMaker'

const MakerRoute = () => {
  return (
    <Switch>
        <Route exact path ="/maker">
          <Maker />
        </Route>
        <Route exact path ="/maker/:tabname/:id">
          <EditAndViewMaker />
        </Route>
    </Switch>
  )
}

export default MakerRoute
